import React from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { RootState } from "../../../../../../models";
import { isBankIdVerified } from "../../../../authentication/state/selectors";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import { submit } from "../../../state/actions";
import * as AT from "../../../state/actionTypes";
import TEXT from "../../../text-consts";

interface StateProps {
    canSubmitOrder: boolean;
    isSubmittingOrder: boolean;
}

interface DispatchProps {
    onSubmit: () => void;
}

type PersonalDetailsContinueButtonProps = StateProps & DispatchProps;

const PersonalDetailsContinueButton: React.FC<PersonalDetailsContinueButtonProps> = ({
    isSubmittingOrder,
    canSubmitOrder,
    onSubmit,
}) => (
    <Button
        id="personal-details-form-button"
        loading={isSubmittingOrder}
        variant="primary"
        disabled={!canSubmitOrder || isSubmittingOrder}
        onClick={onSubmit}
    >
        {TEXT.BUTTON.ORDER}
    </Button>
);

const mapStateToProps = (state: RootState): StateProps => ({
    isSubmittingOrder: LOADING_SELECTORS.isTypeLoading(state, AT.FWA_UPDATE_CUSTOMER_AND_SUBMIT),
    canSubmitOrder: isBankIdVerified(state),
});

const mapDispatchToProps = {
    onSubmit: submit,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetailsContinueButton);
